export class Toolbar {
  constructor({ toolRegistry, onSelect, enabledTools }) {
    this.toolRegistry = toolRegistry;
    this.onSelect = onSelect;
    this.enabledTools = enabledTools;
  }

  mount(container) {
    const bar = document.createElement("div");
    bar.className = "drawing-toolbar";
    const toolIds = Array.isArray(this.enabledTools)
      ? this.toolRegistry.list().filter((toolId) => this.enabledTools.includes(toolId))
      : this.toolRegistry.list();

    for (const toolId of toolIds) {
      const button = document.createElement("button");
      button.type = "button";
      button.textContent = toolId;
      button.addEventListener("click", () => this.onSelect(toolId));
      bar.appendChild(button);
    }

    container.appendChild(bar);
  }
}
